import React from 'react';
import './cta.css';

const CTA = () => (
  <div className="gpt3__cta">
    <div className="gpt3__cta-content">
      <p>Receive the latest news</p>
      <h3>Register Today & get informed about our services.</h3>
    </div>
    <div className="gpt3__cta-btn">
      <button type="button">Subscribe</button>
    </div>
  </div>
);

export default CTA;
